/**
 * BSDatepicker.js
 *
 * Bootstrap datepicker input component wrapper.
 */

import React, { Component } from 'react';

class BSDatepicker extends Component {
  componentDidMount() {
    if (window.$ && window.$().datepicker) {
      window
        .$(this.inputRef)
        .datepicker({
          ...this.props.datepickerOpts,
        })
        .on('changeDate', this.props.onChange);
    } else {
      console.warn('$.datepicker missing');
    }
  }

  render() {
    const { datepickerOpts, ...otherProps } = this.props;

    return (
      <input
        type="text"
        placeholder="Pick a date"
        {...otherProps}
        ref={(c) => (this.inputRef = c)}
      />
    );
  }
}

export default BSDatepicker;
